import { clsx } from 'clsx';
import { FC } from 'react';
import { ReactPlayerProps } from 'react-player';
import { VideolyserPlayer } from './VideolyserPlayer';
import { YoutubePlayer } from './YoutubePlayer';
import styles from './styles.module.css';

interface IVideoPayer extends Omit<ReactPlayerProps, 'url'> {
  url: string;
  isSlider?: boolean;
  className?: string;
}

export const VideoPlayer: FC<IVideoPayer> = ({
  url,
  isSlider,
  className,
  ...props
}) => {
  const isVideolyser = url?.toString().includes('videolyser');
  const Player = isVideolyser ? VideolyserPlayer : YoutubePlayer;

  return (
    <div className={className}>
      <div
        className={clsx(styles.playerWrapper, isSlider && styles.sliderPlayer)}
      >
        <Player url={url} {...props} />
      </div>
    </div>
  );
};
